import { Type } from "class-transformer";
import { computed } from "mobx";
import type { EntityValidationRules } from "../services/validationService";
import ChargePrice from "./chargePrice";
import ChargeValidity from "./chargeValidity";

export const czkCurrencyCode = "CZK";

export default class ChargeType {
  id: string;
  chargeCode: string;
  description: string;
  currencyCode: string;
  isValid: boolean;
  name: string;
  validFor: ChargeValidity;
  @Type(() => ChargePrice)
  prices: ChargePrice[] = [];
  @Type(() => Date)
  validSince: Date;
  @Type(() => Date)
  validUntil?: Date;
  notifyDaysBefore: number;

  @computed
  get code() {
    return this.chargeCode;
  }
}

export const ChargeTypeValidationRules: EntityValidationRules<ChargeType> = {
  name: {
    required: true,
    isLength: {
      max: 100,
    },
  },
  chargeCode: {
    required: true,
    isLength: {
      max: 20,
    },
  },
  currencyCode: {
    required: true,
  },
  validFor: {
    required: true,
  },
  validSince: {
    required: true,
    isBefore: {
      condition: (entity: ChargeType) => entity.validUntil,
      customMessage: "beforeUntilDate",
    },
  },
  validUntil: {
    isAfter: {
      condition: (entity: ChargeType) => entity.validSince,
      customMessage: "afterSinceDate",
    },
  },
  notifyDaysBefore: {
    required: true,
    isInteger: true,
    range: {
      min: 0,
      max: (entity: ChargeType) => {
        switch (entity.validFor) {
          case ChargeValidity.Annual:
            return 365;
          case ChargeValidity.Days30:
            return 30;
          case ChargeValidity.Days10:
            return 10;
          case ChargeValidity.SingleDay:
            return 1;
        }
      },
    },
  },
};
